import React from "react";
import {LogoContainer} from "./style";
import {withRouter, NavLink} from "react-router-dom";

const Logo = (props) => {
  if(props.onClick){
    return (
        <LogoContainer onClick={()=>props.onClick()}>
          <div className="logo-mapsa-container">
            <div className="logo">
              <img src="/images/logo-32.png" alt="mapsa" />
            </div>
            <div className="title">
              <div>مپســا</div>
              <div>حسابداری‌ پروژه</div>
            </div>
          </div>
        </LogoContainer>
    );
  }
  else {
    return (
        <LogoContainer>
          <NavLink className="logo-mapsa-container" to="/">
            <div className="logo">
              <img src="/images/logo-32.png" alt="mapsa" />
            </div>
            <div className="title">
              <div>مپســا</div>
              <div>حسابداری‌ پروژه</div>
            </div>
          </NavLink>
        </LogoContainer>
    );
  }

};

export default withRouter(Logo);